<msd-segmented-navigation [items]="segmentedItems" [ulrPos]="4" style="min-height: 35px;"></msd-segmented-navigation>

<div id="scheduled-task-wrapper">
  <router-outlet></router-outlet>
</div>


